// app/incontro/incontri.js

(function () {
    'use strict';
    var controllerId = 'incontro';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$scope', '$rootScope', '$routeParams', '$filter', '$uibModal', '$q', 'datacontext', 'sectionMenu', incontro]);

    function incontro(common, bDialog, $scope, $rootScope, $routeParams, $filter, $uibModal, $q, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Incontri';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.super = $rootScope.isAuthorized('SUPER');

        vm.objName = "incontro"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        
        vm.contratti = [];

        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['data'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };        


        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;
        

        //il commerciale loggato
        vm.commerciale = $rootScope.commerciale;
       
        //Filtro
        vm.filter = {};
        vm.fContrattoId = 0;
        vm.filter.contrattoId = vm.fContrattoId;

        //Elenchi per parametri implementati
        vm.lstTipoIncontro = [];
                      
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.newFile = {};
        vm.uploadFile = uploadFile;
        vm.download = downloadFile;
       
        //DatePicker
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened1 = false;
        };
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = !vm.opened1;
            vm.opened = false;            
        };
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getContratti(), getTipoIncontro()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.IncontroId != null) {
                            setView('detail');
                            getRecord($routeParams.IncontroId, 0);
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            
            vm.filter.contrattoId = vm.fContrattoId == null ? 0 : vm.fContrattoId;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.contrattoIncontro_countAll(vm.filter.contrattoId, vm.commerciale.Id).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.contrattoIncontro_getAll(vm.pageSize, vm.page, vm.filter.contrattoId, vm.commerciale.Id).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }                
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.contrattoIncontro_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                if ((vm.record.DataPrevista) != null) vm.record.DataPrevista = new Date(vm.record.DataPrevista);
                if ((vm.record.DataEffettuato) != null) vm.record.DataEffettuato = new Date(vm.record.DataEffettuato);

                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.contrattoIncontro_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            return datacontext.contrattoIncontro_update(vm.record).then(function (data) {
                vm.records[vm.index] = data;
                logSuccess('Dato salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' incontro del ' + $filter('date')(item.DataEffettuato, 'dd/MM/yyyy');
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.contrattoIncontro_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        function getContratti() {
            return datacontext.contratto_getAllList().then(function (data) {
                return vm.contratti = data;
            });
        }

        function deleteIncontro(item) {
            var msg = "l'incontro " + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.contrattoIncontro_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');
                    return getListIncontri(vm.record.Id);
                });
            });
        }

        //parametri implementati
        function getTipoIncontro() {
            if (vm.lstTipoIncontro.lenght > 0) return;

            datacontext.tipoIncontro_getAllList().then(function (data) {
                vm.lstTipoIncontro = data;
            });
        }

        function uploadFile(type) {           
            if(typeof(vm.file) == undefined || vm.file == '')
                return false;            

            var filename = type == 'P' ? $('#fileUploadP').val() : $('#fileUploadE').val();

            if (typeof(filename) == 'undefined' || filename == '' || filename == null)
                return false;
            
            vm.loading = true;
            return $q.when(datacontext.contrattoAttach_fileUpload(vm.record.Id, filename, vm.file, type)).then(function (data) {                
                if (data) {
                    getListAttachP(vm.record.Id);
                    getListAttachE(vm.record.Id);
                }
                else
                    logError("Impossibile caricare il file");

                vm.loading = false;
                $('#fileUploadP').val(null);
                $('#fileUploadE').val(null);
            });
        }

        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }

        function downloadFile(id, fileName) {
            common.$http.get('/api/contrattoAttach/FileDownload/' + id, { responseType: 'arraybuffer' })
                .then(function (response) {                    
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data]);
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;
                    if (detectIE())
                        window.navigator.msSaveBlob(file, fileName);
                    else
                        a.download = fileName;
                    a.click();
                    document.body.removeChild(a);
                })
                .catch(function (message) {
                    logError('Impossibile scaricare il file');
                });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var contratti = getContratti();
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incontro/modal/incontroAdd.html?version=43',
                controller: 'incontroAdd',
                resolve: {
                    contratti: function () {
                        return contratti;
                    },
                    contrattoId: function () {
                        return null;
                    },
                    tipoIncontri: function () {
                        return vm.lstTipoIncontro;
                    }
                }
            });           
            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                addRecord(returnItem.Id);
            });
        }
    }
})();
